import CreateTemplateTab from "../../components/CreateTamplateTab";
import ChooseTemplate from "../../components/Forms/ChooseTemplate";
import BasicCard from "../BasicCard"
import Dummylayout from "../Dummylayout";
function ChooseTemplatemain(){

    return(
       <>
       <Dummylayout/>
     <BasicCard>
        <ChooseTemplate/>
     </BasicCard>
     
        
       </>

    )
};
export default ChooseTemplatemain;
